module.exports = __webpack_public_path__ + "img/Image_3.49c60758.png";